var map = {
	"./be.png": "+7wn",
	"./de.png": "2Kt9",
	"./es.png": "CtrT",
	"./fr.png": "3cPx",
	"./gb.png": "TjUC",
	"./it.png": "8LUY",
	"./lu.png": "MhyK",
	"./nl.png": "xrC0",
	"./po.png": "fjgq",
	"./sui.png": "X6Vx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2qxQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags ^\.\/.*\.png$
// module id = 2qxQ
// module chunks = 0